import * as types from '../actions/ActionTypes';

const reportInitialState = {
    loading: false,
    data: [],
    headers: [],
    error: null,
};

const initialState = {
    timeByProgram: { ...reportInitialState },
    timeByUser: { ...reportInitialState },
    weeklySummary: { ...reportInitialState },
    monthlyDetailed: { ...reportInitialState },
    categorySummary: { ...reportInitialState },
    accountManagerMonthly: { ...reportInitialState },
};

const TimesheetReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_MONTHLY_PROGRAM_TIMESHEET_REQUEST:
            return {
                ...state,
                timeByProgram: {
                    ...state.timeByProgram,
                    loading: true,
                },
            };
        case types.GET_MONTHLY_PROGRAM_TIMESHEET_SUCCESS:
            return {
                ...state,
                timeByProgram: {
                    ...state.timeByProgram,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.CLEAR_MONTHLY_PROGRAM_TIMESHEETS_REPORT:
            return {
                ...state,
                timeByProgram: { ...reportInitialState },
            };
        case types.GET_MONTHLY_PROGRAM_TIMESHEET_FAILURE:
            return {
                ...state,
                timeByProgram: {
                    ...state.timeByProgram,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.GET_MONTHLY_USER_TIMESHEET_REQUEST:
            return {
                ...state,
                timeByUser: {
                    ...state.timeByUser,
                    loading: true,
                },
            };
        case types.GET_MONTHLY_USER_TIMESHEET_SUCCESS:
            return {
                ...state,
                timeByUser: {
                    ...state.timeByUser,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.GET_MONTHLY_USER_TIMESHEET_FAILURE:
        case types.CLEAR_MONTHLY_USER_TIMESHEETS_REPORT:
            return {
                ...state,
                timeByUser: { ...reportInitialState },
            };
        case types.GET_WEEKLY_SUMMARY_TIMESHEET_REQUEST:
            return {
                ...state,
                weeklySummary: {
                    ...state.weeklySummary,
                    loading: true,
                },
            };
        case types.GET_WEEKLY_SUMMARY_TIMESHEET_SUCCESS:
            return {
                ...state,
                weeklySummary: {
                    ...state.weeklySummary,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.GET_WEEKLY_SUMMARY_TIMESHEET_FAILURE:
            return {
                ...state,
                weeklySummary: {
                    ...state.weeklySummary,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.CLEAR_WEEKLY_SUMMARY_TIMESHEETS_REPORT:
            return {
                ...state,
                weeklySummary: { ...reportInitialState },
            };
        case types.GET_MONTHLY_DETAILED_TIMESHEET_REQUEST:
            return {
                ...state,
                monthlyDetailed: {
                    ...state.monthlyDetailed,
                    loading: true,
                },
            };
        case types.GET_MONTHLY_DETAILED_TIMESHEET_SUCCESS:
            return {
                ...state,
                monthlyDetailed: {
                    ...state.monthlyDetailed,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.GET_MONTHLY_DETAILED_TIMESHEET_FAILURE:
            return {
                ...state,
                monthlyDetailed: {
                    ...state.monthlyDetailed,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.CLEAR_MONTHLY_DETAILED_TIMESHEETS_REPORT:
            return {
                ...state,
                monthlyDetailed: { ...reportInitialState },
            };
        case types.GET_CATEGORY_SUMMARY_REPORT_REQUEST:
            return {
                ...state,
                categorySummary: {
                    ...state.categorySummary,
                    loading: true,
                },
            };
        case types.GET_CATEGORY_SUMMARY_REPORT_SUCCESS:
            return {
                ...state,
                categorySummary: {
                    ...state.categorySummary,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.GET_CATEGORY_SUMMARY_REPORT_FAILURE:
            return {
                ...state,
                categorySummary: {
                    ...state.categorySummary,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.CLEAR_CATEGORY_SUMMARY_REPORT:
            return {
                ...state,
                categorySummary: { ...reportInitialState },
            };
        case types.GET_ACCOUNT_MANAGER_MONTHLY_REPORT_REQUEST:
            return {
                ...state,
                accountManagerMonthly: {
                    ...state.accountManagerMonthly,
                    loading: true,
                },
            };
        case types.GET_ACCOUNT_MANAGER_MONTHLY_REPORT_SUCCESS:
            return {
                ...state,
                accountManagerMonthly: {
                    ...state.accountManagerMonthly,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.GET_ACCOUNT_MANAGER_MONTHLY_REPORT_FAILURE:
            return {
                ...state,
                accountManagerMonthly: {
                    ...state.accountManagerMonthly,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.CLEAR_ACCOUNT_MANAGER_MONTHLY_REPORT:
            return {
                ...state,
                accountManagerMonthly: { ...reportInitialState },
            };
        default:
            return state;
    }
};

export default TimesheetReportReducer;
